import { getEmptyLocaleValues } from 'shared/utils/get-empty-locale-values'
import { PaymentSettingsErrorsInterface } from '../types/payment-settings-interface'

export const defaultErrors: PaymentSettingsErrorsInterface = {
  defaultCurrency: '',
  doNotUseVat: '',
  doNotUseVatForSwitzerland: '',
  paymentPageAgreement: getEmptyLocaleValues(),
  salesInvoiceFooter: getEmptyLocaleValues(),
  subscriptionGivingAccess: '',
}
